<h2 class="title">Add Excluded Combination</h2>

<mat-dialog-content>
  <div class="form-container">
    <form [formGroup]="matchrunForm" (ngSubmit)="addExcludedCombination()">
      <!-- Recipient Search -->
      <mat-form-field appearance="fill">
        <mat-label>Recipient</mat-label>
        <input type="text" matInput [matAutocomplete]="recipientAuto" [formControl]="recipientSearchControl" (input)="filterRecipients()" />
        <button type="button" mat-icon-button matSuffix *ngIf="selectedRecipient && !isFromMatchrun" (click)="clearRecipientSelection($event)">
          <mat-icon>clear</mat-icon>
        </button>
        <mat-autocomplete #recipientAuto="matAutocomplete" [displayWith]="displayRecipientName" (optionSelected)="selectRecipient($event.option.value)">
          <mat-option *ngFor="let recipient of filteredRecipients" [value]="recipient">
            {{ recipient.enisNumber }} - {{ recipient.firstName }} {{ recipient.lastName }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>

      <!-- Donor Search -->
      <mat-form-field appearance="fill">
        <mat-label>Donor</mat-label>
        <input type="text" matInput [matAutocomplete]="donorAuto" [formControl]="donorSearchControl" (input)="filterDonors()" />
        <button type="button" mat-icon-button matSuffix *ngIf="selectedDonor && !isFromMatchrun" (click)="clearDonorSelection($event)">
          <mat-icon>clear</mat-icon>
        </button>
        <mat-autocomplete #donorAuto="matAutocomplete" [displayWith]="displayDonorName" (optionSelected)="selectDonor($event.option.value)">
          <mat-option *ngFor="let donor of filteredDonors" [value]="donor">{{ donor.enisNumber }} - {{ donor.firstName }} {{ donor.lastName }} </mat-option>
        </mat-autocomplete>
      </mat-form-field>

      <mat-form-field appearance="fill" id="reason">
        <mat-label>Reason for exclusion</mat-label>
        <mat-select formControlName="reasonExcluded" name="reasonExcludedXXX" required>
          <mat-option *ngFor="let reason of reasons" [value]="reason">
            {{ reasonsLabels[reason] }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Comments</mat-label>
        <textarea matInput formControlName="comments" placeholder="Add any comments about this exclusion..." rows="3"></textarea>
      </mat-form-field>

      <div class="button-container">
        <button mat-raised-button color="primary" type="submit" [disabled]="matchrunForm.invalid">Submit</button>
      </div>
    </form>
  </div>
</mat-dialog-content>
